import { OrgAdminConstants } from '../../../_constants';

const initialState = { csvLoading: true, csvDataResponse: '', csvError: false };

export function csvUploadTeamMembers(state = initialState, action) {
    
    switch (action.type) {
        case OrgAdminConstants.REQUEST_TEAM_CSV_UPLOAD:
            return {
                csvLoading: true,
                csvDataResponse: '',
                csvError: false
            };
        case OrgAdminConstants.RECEIVE_TEAM_CSV_UPLOAD:
            return {
                csvLoading: false,
                csvDataResponse: action.csvUploaded,
                csvError: false
            };
        case OrgAdminConstants.ERROR_TEAM_CSV_UPLOAD:
            return {
                csvLoading: false,
                csvDataResponse: '',
                csvError: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/TeamMemberUpload/csvUploadTeamMembers.js